export default {"src":"/_next/static/media/github copilot.5f144734.svg","height":2531,"width":2531,"blurWidth":0,"blurHeight":0};